import React from 'react';
import PropTypes from 'prop-types';

import { StyledInput, StyledLabel } from './ProductMonogramFieldStyles';

var ProductMonogramFields = function ProductMonogramFields(props) {
  var getMaxLength = function getMaxLength(tags) {
    var length = 0;
    if (tags.includes('monogram--10char')) {
      length = 10;
    } else if (tags.includes('monogram--1char')) {
      length = 1;
    } else if (tags.includes('monogram--3char') || tags.includes('monogram--1to3char')) {
      length = 3;
    } else if (tags.includes('monogram--varsity')) {
      length = 9;
    } else if (tags.includes('monogram--classic')) {
      length = 11;
    } else if (tags.includes('monogram--drop-shadow')) {
      length = 9;
    }
    return length;
  };
  var maxLength = getMaxLength(props.tags);
  var revertErrorState = function revertErrorState() {
    if (props.setMonogramError) props.setMonogramError(false);
  };
  return React.createElement(
    'div',
    null,
    React.createElement(StyledInput, {
      type: 'text',
      placeholder: 'Enter Text (Up to ' + maxLength + ' characters)',
      name: 'Monogram',
      maxLength: maxLength,
      value: props.monogramInputValue,
      onChange: props.handleMonogramInput,
      onFocus: revertErrorState,
      error: props.monogramError
    })
  );
};

ProductMonogramFields.propTypes = {
  tags: PropTypes.array.isRequired,
  monogramInputValue: PropTypes.string,
  handleMonogramInput: PropTypes.func,
  monogramError: PropTypes.bool,
  setMonogramError: PropTypes.func
};

export default React.memo(ProductMonogramFields);